import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewDetails: {
		id: 'portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.connections.connection.view-details',
		defaultMessage: 'View details',
		description: 'Tooltip for connection',
	},
});
